import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Server } from '../../clients/aasServerClient.generated';
import { getAssignablePrivileges } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import FormInput from '../common/FormInput';
import { getMaintenanceMode } from '../../repositories/ServerRepository';
import { setMaintenanceMode } from '../../repositories/ServerRepository';

interface Props extends LocalizeContextProps {
    type: 'edit' | 'new';
    server: Partial<Server>;
    updateServer: (server: Partial<Server>) => void;
}

class ServerProperties extends React.Component<Props, Partial<Server>> {

    public constructor(props: Props) {
        super(props);
        this.state = props.server;
        this.props.updateServer(this.state);
    }

    public render() {
        const t = this.props.translate;
        this.updateMaintenanceMode();
        return (
            <React.Fragment>
                <FormInput
                    row={true}
                    name="hostname"
                    fullName={t('servers.edit.field.hostname') as string}
                    value={this.props.type !== 'edit' ? this.state.hostname || '' : undefined}
                    defaultValue={this.props.type === 'edit' ? this.state.hostname || '' : undefined}
                    onChange={this.props.type !== 'edit' ? this.handleServerChange : undefined}
                    readOnly={this.props.type === 'edit'}
                />
                <FormInput
                    row={true}
                    name="secure"
                    type="checkbox"
                    fullName={t('servers.edit.field.secure') as string}
                    checked={this.props.type !== 'edit' ? this.state.secure || false : undefined}
                    defaultChecked={this.props.type === 'edit' ? this.state.secure || false : undefined}
                    checkboxProp={true}
                    onChange={this.props.type !== 'edit' ? this.handleServerChange : undefined}
                    readOnly={this.props.type === 'edit'}
                />
                {this.props.type === 'edit' ? (
                    <FormInput
                        row={true}
                        name="key"
                        fullName={t('servers.edit.field.key') as string}
                        defaultValue={this.state.key || ''}
                        readOnly={true}
                    />
                ) : null}
                <FormInput
                    row={true}
                    name="atp_url"
                    fullName={t('servers.edit.field.atpUrl') as string}
                    value={this.state.atp_url || ''}
                    onChange={this.handleServerChange}
                />
                {this.props.type === 'edit' ? (
                    <FormInput
                        row={true}
                        name="anagoVersion"
                        fullName={t('servers.edit.field.anagoVersion') as string}
                        defaultValue={this.state.anagoVersion || ''}
                        readOnly={true}
                    />
                ) : null}
                <FormInput
                    row
                    name="maintenanceMode"
                    type="checkbox"
                    fullName="Maintenance Mode"
                    checked={this.state.maintenanceMode}
                    disabled={this.state.maintenanceMode === undefined}
                    checkboxProp={true}
                    onChange={this.handleMaintenanceModeChange.bind(this)}
                />
            </React.Fragment>
        );
    }

    private async updateMaintenanceMode() {
        if (this.props.server.hostname) {
            try {
            var mode = await getMaintenanceMode(this.props.server.hostname);
            if (this.state.maintenanceMode !== mode) {
                this.setState({ maintenanceMode: mode });
            }
        } catch { }
    }
    }

    private async handleMaintenanceModeChange(e: React.ChangeEvent<HTMLInputElement>) {
        var val = e.target.checked ?? false;
        this.setState({ maintenanceMode: val });
        val = await setMaintenanceMode(this.state.hostname!, val);
        const update = { maintenanceMode: val };
        this.setState(update);
        this.props.updateServer({ ...this.state, ...update });
    }

    private handleServerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const update = {
            [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
        };
        this.setState(update);
        this.props.updateServer({ ...this.state, ...update });
    }
}

const mapStateToProps = (state: RootState) => ({
});

export default connect(mapStateToProps)(withLocalize(ServerProperties));